export default __webpack_public_path__ + "static/media/notifications.c26bf835.svg";